import script from "./TvmConfigDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./TvmConfigDialog.vue?vue&type=script&setup=true&lang=js"

import "./TvmConfigDialog.vue?vue&type=style&index=0&id=017aebb7&lang=scss&scoped=true"

import exportComponent from "F:\\work\\git\\yunchi\\yc-vue-source\\yunman\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-017aebb7"]])

export default __exports__